import { logo, successIcon } from "images";
import classes from "./Header.module.css";
import { Heading, Text } from "components/common";
import clsx from "clsx";
const Header = ({ success, heading, info }) => {
  return (
    <div className={clsx(classes.header, success && classes.successContainer)}>
      <img src={success ? successIcon : logo} alt="#" className={classes.img} />
      <Heading lg={success} xl={!success} primary textCenter>
        {heading}
      </Heading>
      <Text primitive300 sm textCenter>
        {info}
      </Text>
    </div>
  );
};
export default Header;
